module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f4a1.d95a2486.svg";